export const ALLOWED_FIELDS = Object.freeze([
  'name',
  'nickName',
  'nickname',
  'category',
  'type',
  'assignedCountry',
  'country',
  'countryOfAcquisition',
  'holder',
  'purchaseValue',
  'bank',
  'dateOfOpening',
  'isTest',
  'address',
  'ownerShipType',
  'owner',
  'isWithCoOwners',
  'ownerShare',
  'coOwners',
  'contactInfoLabel',
  'contactInfoLabelDescription',
  'ownerAddress',
  'phoneNumber',
  'email',
  'plannedDividends',
  'actualDividends',
  'dividendsDelta',
  'independentAppraisalAmount',
  'availableLimit',
  'expenses',
  'buyingPrice',
  'strikePrice',
  'taxBurden',
  'taxAgent',
  'taxAgentOther',
  'publicFundTaxAgent',
  'publicTaxAgentOther',
  'taxAgentWithBroker',
  'taxAgentWithBrokerOther',
  'legalTaxAgent',
  'legalTaxAgentOther',
  'holderTaxAgent',
  'holderTaxAgentOther',
  'limitations',
  'limitationsComments',
  'liquidity',
  'activity',
  'investmentsGoals',
  'outlook',
  'riskRate',
  'informationDisclosure',
  'informationDisclosureDetails',
  'specificsOfTaxation',
  'profitability',
  'profitabilityPlan',
  'profitabilityFact',
  'commentsOnTheAsset',
] as const);
